// @core/api/endpoints/search/re_index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReIndexRequest,
  ReIndexResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Trigger reindex
 * Triggers a full reindex of all documents for the specified search index. The reindex runs asynchronously.
 */
export async function ReIndex(
  index_id: string,
  data: ReIndexRequest,
  options?: RequestOptions
): Promise<ReIndexResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/search/indexes/:index_id/reindex`;
  requestPath = requestPath.replace(':index_id', encodeURIComponent(index_id));
  const requestOptions = options;
  return client.post<ReIndexResponse>(requestPath, data, requestOptions);
}
